import React from 'react';
import {
  DARWIN_NAVY,
  DARWIN_BLUE,
  DARWIN_YELLOW,
  DARWIN_RED_2,
} from '../../constants';

export const NavLogo = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="131"
      height="32"
      viewBox="0 0 131 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2323 4.02991C14.1183 4.02991 16.6403 4.60191 18.7983 5.74591C20.9563 6.88991 22.6203 8.50191 23.7903 10.5819C24.9863 12.6359 25.5843 15.0149 25.5843 17.7189C25.5843 20.3969 24.9863 22.7759 23.7903 24.8559C22.6203 26.9359 20.9433 28.5479 18.7593 29.6919C16.6013 30.8359 14.0923 31.4079 11.2323 31.4079H0.975342V4.02991H11.2323ZM10.8033 25.6359C13.3253 25.6359 15.2883 24.9469 16.6923 23.5689C18.0963 22.1909 18.7983 20.2409 18.7983 17.7189C18.7983 15.1969 18.0963 13.2339 16.6923 11.8299C15.2883 10.4259 13.3253 9.72391 10.8033 9.72391H7.64434V25.6359H10.8033Z"
        fill="#1E2B4E"
      />
      <path
        d="M26.2303 20.4879C26.2303 18.2519 26.6463 16.2889 27.4783 14.5989C28.3363 12.9089 29.4933 11.6089 30.9493 10.6989C32.4053 9.78891 34.0303 9.33391 35.8243 9.33391C37.3583 9.33391 38.6973 9.64591 39.8413 10.2699C41.0113 10.8939 41.9083 11.7129 42.5323 12.7269V9.64591H49.2013V31.4079H42.5323V28.3269C41.8823 29.3409 40.9723 30.1599 39.8023 30.7839C38.6583 31.4079 37.3193 31.7199 35.7853 31.7199C34.0173 31.7199 32.4053 31.2649 30.9493 30.3549C29.4933 29.4189 28.3363 28.1059 27.4783 26.4159C26.6463 24.6999 26.2303 22.7239 26.2303 20.4879ZM42.5323 20.5269C42.5323 18.8629 42.0643 17.5499 41.1283 16.5879C40.2183 15.6259 39.1003 15.1449 37.7743 15.1449C36.4483 15.1449 35.3173 15.6259 34.3813 16.5879C33.4713 17.5239 33.0163 18.8239 33.0163 20.4879C33.0163 22.1519 33.4713 23.4779 34.3813 24.4659C35.3173 25.4279 36.4483 25.9089 37.7743 25.9089C39.1003 25.9089 40.2183 25.4279 41.1283 24.4659C42.0643 23.5039 42.5323 22.1909 42.5323 20.5269Z"
        fill="#1E2B4E"
      />
      <path
        d="M58.94 13.2729C59.72 12.0769 60.695 11.1409 61.865 10.4649C63.035 9.76291 64.335 9.41191 65.765 9.41191V16.4709H63.932C62.268 16.4709 61.02 16.8349 60.188 17.5629C59.356 18.2649 58.94 19.5129 58.94 21.3069V31.4079H52.271V9.64591H58.94V13.2729Z"
        fill="#1E2B4E"
      />
      <path
        d="M98.4366 9.64591L92.5476 31.4079H85.1766L81.7447 17.2899L78.1956 31.4079H70.8636L64.9356 9.64591H71.6046L74.6856 25.2069L78.3516 9.64591H85.4107L89.1156 25.1289L92.1576 9.64591H98.4366Z"
        fill="#1E2B4E"
      />
      <path
        d="M105.894 9.64591V31.4079H99.2249V9.64591H105.894Z"
        fill="#1E2B4E"
      />
      <path
        d="M122.232 9.41191C124.78 9.41191 126.808 10.2439 128.316 11.9079C129.85 13.5459 130.617 15.8079 130.617 18.6939V31.4079H123.987V19.5909C123.987 18.1349 123.61 17.0039 122.856 16.1979C122.102 15.3919 121.088 14.9889 119.814 14.9889C118.54 14.9889 117.526 15.3919 116.772 16.1979C116.018 17.0039 115.641 18.1349 115.641 19.5909V31.4079H108.972V9.64591H115.641V12.5319C116.317 11.5699 117.227 10.8159 118.371 10.2699C119.515 9.69791 120.802 9.41191 122.232 9.41191Z"
        fill="#1E2B4E"
      />
      <path
        className="logo-dot"
        d="M106.513 3.94644C106.513 6.02919 104.735 7.7176 102.542 7.7176C100.348 7.7176 98.5703 6.02919 98.5703 3.94644C98.5703 1.86369 100.112 0.175293 102.542 0.175293C104.735 0.175293 106.513 1.63454 106.513 3.94644Z"
        fill="#039BE5"
      />
    </svg>
  );
};

export const RoadmapIcon = ({ className }) => {
  return (
    <div className="icon-wrapper">
      <svg
        className={`${className} ${className}-backdrop roadmap-icon`}
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 2.8125C15 4.2832 13.2686 6.47754 12.5215 7.35352C12.4102 7.48242 12.2461 7.53223 12.0967 7.5H9.375C8.85645 7.5 8.4375 7.91895 8.4375 8.4375C8.4375 8.95605 8.85645 9.375 9.375 9.375H12.1875C13.7402 9.375 15 10.6348 15 12.1875C15 13.7402 13.7402 15 12.1875 15H4.08984C4.34473 14.71 4.65527 14.3379 4.96875 13.9219C5.15332 13.6758 5.34375 13.4063 5.52539 13.125H12.1875C12.7061 13.125 13.125 12.7061 13.125 12.1875C13.125 11.6689 12.7061 11.25 12.1875 11.25H9.375C7.82227 11.25 6.5625 9.99023 6.5625 8.4375C6.5625 6.88477 7.82227 5.625 9.375 5.625H10.541C9.92578 4.70215 9.375 3.6416 9.375 2.8125C9.375 1.25977 10.6348 0 12.1875 0C13.7402 0 15 1.25977 15 2.8125ZM3.43066 14.3291C3.31934 14.4551 3.21973 14.5664 3.13477 14.6602L3.08203 14.7187L3.07617 14.7129C2.90039 14.8477 2.64844 14.8301 2.49023 14.6602C1.75195 13.8574 0 11.792 0 10.3125C0 8.75977 1.25977 7.5 2.8125 7.5C4.36523 7.5 5.625 8.75977 5.625 10.3125C5.625 11.1914 5.00684 12.2754 4.35059 13.1807C4.03711 13.6113 3.71484 14.001 3.44824 14.3086L3.43066 14.3291ZM3.75 10.3125C3.75 10.0639 3.65123 9.8254 3.47541 9.64959C3.2996 9.47377 3.06114 9.375 2.8125 9.375C2.56386 9.375 2.3254 9.47377 2.14959 9.64959C1.97377 9.8254 1.875 10.0639 1.875 10.3125C1.875 10.5611 1.97377 10.7996 2.14959 10.9754C2.3254 11.1512 2.56386 11.25 2.8125 11.25C3.06114 11.25 3.2996 11.1512 3.47541 10.9754C3.65123 10.7996 3.75 10.5611 3.75 10.3125ZM12.1875 3.75C12.4361 3.75 12.6746 3.65123 12.8504 3.47541C13.0262 3.2996 13.125 3.06114 13.125 2.8125C13.125 2.56386 13.0262 2.3254 12.8504 2.14959C12.6746 1.97377 12.4361 1.875 12.1875 1.875C11.9389 1.875 11.7004 1.97377 11.5246 2.14959C11.3488 2.3254 11.25 2.56386 11.25 2.8125C11.25 3.06114 11.3488 3.2996 11.5246 3.47541C11.7004 3.65123 11.9389 3.75 12.1875 3.75Z"
          fill={DARWIN_RED_2}
        />
      </svg>

      <svg
        className={`${className} roadmap-icon`}
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 2.8125C15 4.2832 13.2686 6.47754 12.5215 7.35352C12.4102 7.48242 12.2461 7.53223 12.0967 7.5H9.375C8.85645 7.5 8.4375 7.91895 8.4375 8.4375C8.4375 8.95605 8.85645 9.375 9.375 9.375H12.1875C13.7402 9.375 15 10.6348 15 12.1875C15 13.7402 13.7402 15 12.1875 15H4.08984C4.34473 14.71 4.65527 14.3379 4.96875 13.9219C5.15332 13.6758 5.34375 13.4063 5.52539 13.125H12.1875C12.7061 13.125 13.125 12.7061 13.125 12.1875C13.125 11.6689 12.7061 11.25 12.1875 11.25H9.375C7.82227 11.25 6.5625 9.99023 6.5625 8.4375C6.5625 6.88477 7.82227 5.625 9.375 5.625H10.541C9.92578 4.70215 9.375 3.6416 9.375 2.8125C9.375 1.25977 10.6348 0 12.1875 0C13.7402 0 15 1.25977 15 2.8125ZM3.43066 14.3291C3.31934 14.4551 3.21973 14.5664 3.13477 14.6602L3.08203 14.7187L3.07617 14.7129C2.90039 14.8477 2.64844 14.8301 2.49023 14.6602C1.75195 13.8574 0 11.792 0 10.3125C0 8.75977 1.25977 7.5 2.8125 7.5C4.36523 7.5 5.625 8.75977 5.625 10.3125C5.625 11.1914 5.00684 12.2754 4.35059 13.1807C4.03711 13.6113 3.71484 14.001 3.44824 14.3086L3.43066 14.3291ZM3.75 10.3125C3.75 10.0639 3.65123 9.8254 3.47541 9.64959C3.2996 9.47377 3.06114 9.375 2.8125 9.375C2.56386 9.375 2.3254 9.47377 2.14959 9.64959C1.97377 9.8254 1.875 10.0639 1.875 10.3125C1.875 10.5611 1.97377 10.7996 2.14959 10.9754C2.3254 11.1512 2.56386 11.25 2.8125 11.25C3.06114 11.25 3.2996 11.1512 3.47541 10.9754C3.65123 10.7996 3.75 10.5611 3.75 10.3125ZM12.1875 3.75C12.4361 3.75 12.6746 3.65123 12.8504 3.47541C13.0262 3.2996 13.125 3.06114 13.125 2.8125C13.125 2.56386 13.0262 2.3254 12.8504 2.14959C12.6746 1.97377 12.4361 1.875 12.1875 1.875C11.9389 1.875 11.7004 1.97377 11.5246 2.14959C11.3488 2.3254 11.25 2.56386 11.25 2.8125C11.25 3.06114 11.3488 3.2996 11.5246 3.47541C11.7004 3.65123 11.9389 3.75 12.1875 3.75Z"
          fill="#1E2B4E"
        />
      </svg>
    </div>
  );
};

export const LibraryIcon = ({ className }) => {
  return (
    <div className="icon-wrapper">
      <svg
        className={`${className} ${className}-backdrop`}
        width="20"
        height="20"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.25 3.35413H4.75C4.12011 3.35413 3.51602 3.61752 3.07062 4.08636C2.62522 4.5552 2.375 5.19108 2.375 5.85413V15.8541C2.375 16.5172 2.62522 17.1531 3.07062 17.6219C3.51602 18.0907 4.12011 18.3541 4.75 18.3541H14.25C14.8799 18.3541 15.484 18.0907 15.9294 17.6219C16.3748 17.1531 16.625 16.5172 16.625 15.8541V5.85413C16.625 5.19108 16.3748 4.5552 15.9294 4.08636C15.484 3.61752 14.8799 3.35413 14.25 3.35413ZM4.75 5.02079H14.25C14.46 5.02079 14.6613 5.10859 14.8098 5.26487C14.9583 5.42115 15.0417 5.63311 15.0417 5.85413V12.8208L12.5083 10.5458C12.1158 10.2058 11.6233 10.02 11.115 10.02C10.6067 10.02 10.1142 10.2058 9.72167 10.5458L3.95833 15.6041V5.85413C3.95833 5.63311 4.04174 5.42115 4.19021 5.26487C4.33867 5.10859 4.54004 5.02079 4.75 5.02079V5.02079Z"
          fill="#7B66FE"
        />
        <path
          d="M6.33325 9.18744C6.98909 9.18744 7.52075 8.62779 7.52075 7.93744C7.52075 7.24708 6.98909 6.68744 6.33325 6.68744C5.67741 6.68744 5.14575 7.24708 5.14575 7.93744C5.14575 8.62779 5.67741 9.18744 6.33325 9.18744Z"
          fill="#7B66FE"
        />
      </svg>

      <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.25 3.35413H4.75C4.12011 3.35413 3.51602 3.61752 3.07062 4.08636C2.62522 4.5552 2.375 5.19108 2.375 5.85413V15.8541C2.375 16.5172 2.62522 17.1531 3.07062 17.6219C3.51602 18.0907 4.12011 18.3541 4.75 18.3541H14.25C14.8799 18.3541 15.484 18.0907 15.9294 17.6219C16.3748 17.1531 16.625 16.5172 16.625 15.8541V5.85413C16.625 5.19108 16.3748 4.5552 15.9294 4.08636C15.484 3.61752 14.8799 3.35413 14.25 3.35413ZM4.75 5.02079H14.25C14.46 5.02079 14.6613 5.10859 14.8098 5.26487C14.9583 5.42115 15.0417 5.63311 15.0417 5.85413V12.8208L12.5083 10.5458C12.1158 10.2058 11.6233 10.02 11.115 10.02C10.6067 10.02 10.1142 10.2058 9.72167 10.5458L3.95833 15.6041V5.85413C3.95833 5.63311 4.04174 5.42115 4.19021 5.26487C4.33867 5.10859 4.54004 5.02079 4.75 5.02079V5.02079Z"
          fill="#1E2B4E"
        />
        <path
          d="M6.33325 9.18744C6.98909 9.18744 7.52075 8.62779 7.52075 7.93744C7.52075 7.24708 6.98909 6.68744 6.33325 6.68744C5.67741 6.68744 5.14575 7.24708 5.14575 7.93744C5.14575 8.62779 5.67741 9.18744 6.33325 9.18744Z"
          fill="#1E2B4E"
        />
      </svg>
    </div>
  );
};

// export const AnalyticsIcon = ({ className }) => {
//   return (
//     <div className="icon-wrapper">
//       <svg
//         className={`${className} ${className}-backdrop`}
//         width="20"
//         height="20"
//         viewBox="0 0 25 25"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M21.006 8.35413C19.556 8.35413 18.746 9.79413 19.076 10.8641L15.526 14.4241C15.226 14.3341 14.786 14.3341 14.486 14.4241L11.936 11.8741C12.276 10.8041 11.466 9.35413 10.006 9.35413C8.55598 9.35413 7.73598 10.7941 8.07598 11.8741L3.51598 16.4241C2.44598 16.0941 1.00598 16.9041 1.00598 18.3541C1.00598 19.4541 1.90598 20.3541 3.00598 20.3541C4.45598 20.3541 5.26598 18.9141 4.93598 17.8441L9.48598 13.2841C9.78598 13.3741 10.226 13.3741 10.526 13.2841L13.076 15.8341C12.736 16.9041 13.546 18.3541 15.006 18.3541C16.456 18.3541 17.276 16.9141 16.936 15.8341L20.496 12.2841C21.566 12.6141 23.006 11.8041 23.006 10.3541C23.006 9.25413 22.106 8.35413 21.006 8.35413Z"
//           fill={DARWIN_BLUE}
//         />
//         <path
//           d="M15.006 9.35413L15.946 7.28413L18.006 6.35413L15.946 5.42413L15.006 3.35413L14.086 5.42413L12.006 6.35413L14.086 7.28413L15.006 9.35413ZM3.50598 11.3541L4.00598 9.35413L6.00598 8.85413L4.00598 8.35413L3.50598 6.35413L3.00598 8.35413L1.00598 8.85413L3.00598 9.35413L3.50598 11.3541Z"
//           fill={DARWIN_BLUE}
//         />
//         <path
//           d="M15.006 9.35413L15.946 7.28413L18.006 6.35413L15.946 5.42413L15.006 3.35413L14.086 5.42413L12.006 6.35413L14.086 7.28413L15.006 9.35413ZM3.50598 11.3541L4.00598 9.35413L6.00598 8.85413L4.00598 8.35413L3.50598 6.35413L3.00598 8.35413L1.00598 8.85413L3.00598 9.35413L3.50598 11.3541Z"
//           fill="black"
//           fillOpacity="0.2"
//         />
//       </svg>
//       <svg
//         className={className}
//         width="20"
//         height="20"
//         viewBox="0 0 25 25"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M21.006 8.35413C19.556 8.35413 18.746 9.79413 19.076 10.8641L15.526 14.4241C15.226 14.3341 14.786 14.3341 14.486 14.4241L11.936 11.8741C12.276 10.8041 11.466 9.35413 10.006 9.35413C8.55598 9.35413 7.73598 10.7941 8.07598 11.8741L3.51598 16.4241C2.44598 16.0941 1.00598 16.9041 1.00598 18.3541C1.00598 19.4541 1.90598 20.3541 3.00598 20.3541C4.45598 20.3541 5.26598 18.9141 4.93598 17.8441L9.48598 13.2841C9.78598 13.3741 10.226 13.3741 10.526 13.2841L13.076 15.8341C12.736 16.9041 13.546 18.3541 15.006 18.3541C16.456 18.3541 17.276 16.9141 16.936 15.8341L20.496 12.2841C21.566 12.6141 23.006 11.8041 23.006 10.3541C23.006 9.25413 22.106 8.35413 21.006 8.35413Z"
//           fill="#1E2B4E"
//         />
//         <path
//           d="M15.006 9.35413L15.946 7.28413L18.006 6.35413L15.946 5.42413L15.006 3.35413L14.086 5.42413L12.006 6.35413L14.086 7.28413L15.006 9.35413ZM3.50598 11.3541L4.00598 9.35413L6.00598 8.85413L4.00598 8.35413L3.50598 6.35413L3.00598 8.35413L1.00598 8.85413L3.00598 9.35413L3.50598 11.3541Z"
//           fill="#1E2B4E"
//         />
//         <path
//           d="M15.006 9.35413L15.946 7.28413L18.006 6.35413L15.946 5.42413L15.006 3.35413L14.086 5.42413L12.006 6.35413L14.086 7.28413L15.006 9.35413ZM3.50598 11.3541L4.00598 9.35413L6.00598 8.85413L4.00598 8.35413L3.50598 6.35413L3.00598 8.35413L1.00598 8.85413L3.00598 9.35413L3.50598 11.3541Z"
//           fill="black"
//           fillOpacity="0.2"
//         />
//       </svg>
//     </div>
//   );
// };

export const AnalyticsIcon = ({ isSelected, className }) => {
  return (
    <div className="icon-wrapper">
      <svg
        className={`${className} ${className}-backdrop`}
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.006 8.35413C19.556 8.35413 18.746 9.79413 19.076 10.8641L15.526 14.4241C15.226 14.3341 14.786 14.3341 14.486 14.4241L11.936 11.8741C12.276 10.8041 11.466 9.35413 10.006 9.35413C8.55598 9.35413 7.73598 10.7941 8.07598 11.8741L3.51598 16.4241C2.44598 16.0941 1.00598 16.9041 1.00598 18.3541C1.00598 19.4541 1.90598 20.3541 3.00598 20.3541C4.45598 20.3541 5.26598 18.9141 4.93598 17.8441L9.48598 13.2841C9.78598 13.3741 10.226 13.3741 10.526 13.2841L13.076 15.8341C12.736 16.9041 13.546 18.3541 15.006 18.3541C16.456 18.3541 17.276 16.9141 16.936 15.8341L20.496 12.2841C21.566 12.6141 23.006 11.8041 23.006 10.3541C23.006 9.25413 22.106 8.35413 21.006 8.35413Z"
          fill={isSelected ? DARWIN_BLUE : '#1E2B4E'}
        />
        <path
          d="M15.006 9.35413L15.946 7.28413L18.006 6.35413L15.946 5.42413L15.006 3.35413L14.086 5.42413L12.006 6.35413L14.086 7.28413L15.006 9.35413ZM3.50598 11.3541L4.00598 9.35413L6.00598 8.85413L4.00598 8.35413L3.50598 6.35413L3.00598 8.35413L1.00598 8.85413L3.00598 9.35413L3.50598 11.3541Z"
          fill={isSelected ? DARWIN_BLUE : '#1E2B4E'}
        />
        <path
          d="M15.006 9.35413L15.946 7.28413L18.006 6.35413L15.946 5.42413L15.006 3.35413L14.086 5.42413L12.006 6.35413L14.086 7.28413L15.006 9.35413ZM3.50598 11.3541L4.00598 9.35413L6.00598 8.85413L4.00598 8.35413L3.50598 6.35413L3.00598 8.35413L1.00598 8.85413L3.00598 9.35413L3.50598 11.3541Z"
          fill="black"
          fillOpacity="0.2"
        />
      </svg>
    </div>
  );
};

// export const StudioIcon = ({ isSelected, className }) => {
//   return (
//     <div className="icon-wrapper">
//       <svg
//         className={`${className} ${className}-backdrop`}
//         width="20"
//         height="20"
//         viewBox="0 0 25 25"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M6.42249 13.1043C4.96999 13.1043 3.79749 14.2768 3.79749 15.7293C3.79749 16.8755 2.78249 17.4793 2.04749 17.4793C2.85249 18.5468 4.22624 19.2293 5.54749 19.2293C7.48124 19.2293 9.04749 17.663 9.04749 15.7293C9.04749 14.2768 7.87499 13.1043 6.42249 13.1043ZM18.4187 4.9055L17.2462 3.733C17.1653 3.65188 17.0691 3.58753 16.9633 3.54362C16.8574 3.49971 16.744 3.47711 16.6294 3.47711C16.5148 3.47711 16.4013 3.49971 16.2954 3.54362C16.1896 3.58753 16.0934 3.65188 16.0125 3.733L8.17249 11.573L10.5787 13.9793L18.4187 6.13925C18.4998 6.0583 18.5642 5.96215 18.6081 5.8563C18.652 5.75045 18.6746 5.63697 18.6746 5.52238C18.6746 5.40778 18.652 5.29431 18.6081 5.18845C18.5642 5.0826 18.4998 4.98645 18.4187 4.9055Z"
//           fill={DARWIN_YELLOW}
//         />
//       </svg>
//       <svg
//         className={className}
//         width="20"
//         height="20"
//         viewBox="0 0 25 25"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M6.42249 13.1043C4.96999 13.1043 3.79749 14.2768 3.79749 15.7293C3.79749 16.8755 2.78249 17.4793 2.04749 17.4793C2.85249 18.5468 4.22624 19.2293 5.54749 19.2293C7.48124 19.2293 9.04749 17.663 9.04749 15.7293C9.04749 14.2768 7.87499 13.1043 6.42249 13.1043ZM18.4187 4.9055L17.2462 3.733C17.1653 3.65188 17.0691 3.58753 16.9633 3.54362C16.8574 3.49971 16.744 3.47711 16.6294 3.47711C16.5148 3.47711 16.4013 3.49971 16.2954 3.54362C16.1896 3.58753 16.0934 3.65188 16.0125 3.733L8.17249 11.573L10.5787 13.9793L18.4187 6.13925C18.4998 6.0583 18.5642 5.96215 18.6081 5.8563C18.652 5.75045 18.6746 5.63697 18.6746 5.52238C18.6746 5.40778 18.652 5.29431 18.6081 5.18845C18.5642 5.0826 18.4998 4.98645 18.4187 4.9055Z"
//           fill="#1E2B4E"
//         />
//       </svg>
//     </div>
//   );
// };

export const StudioIcon = ({ isSelected, className }) => {
  return (
    <div className="icon-wrapper">
      <svg
        className={`${className} ${className}-backdrop`}
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.42249 13.1043C4.96999 13.1043 3.79749 14.2768 3.79749 15.7293C3.79749 16.8755 2.78249 17.4793 2.04749 17.4793C2.85249 18.5468 4.22624 19.2293 5.54749 19.2293C7.48124 19.2293 9.04749 17.663 9.04749 15.7293C9.04749 14.2768 7.87499 13.1043 6.42249 13.1043ZM18.4187 4.9055L17.2462 3.733C17.1653 3.65188 17.0691 3.58753 16.9633 3.54362C16.8574 3.49971 16.744 3.47711 16.6294 3.47711C16.5148 3.47711 16.4013 3.49971 16.2954 3.54362C16.1896 3.58753 16.0934 3.65188 16.0125 3.733L8.17249 11.573L10.5787 13.9793L18.4187 6.13925C18.4998 6.0583 18.5642 5.96215 18.6081 5.8563C18.652 5.75045 18.6746 5.63697 18.6746 5.52238C18.6746 5.40778 18.652 5.29431 18.6081 5.18845C18.5642 5.0826 18.4998 4.98645 18.4187 4.9055Z"
          fill={isSelected ? DARWIN_BLUE : '#1E2B4E'}
        />
      </svg>
    </div>
  );
};

export const TestingIcon = ({ className }) => {
  return (
    <div className="icon-wrapper">
      <svg
        className={`${className} ${className}-backdrop`}
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8718 8.28425L21.4618 6.87425L17.4318 11.4042L10.3718 4.85425L2.87183 12.3642L4.37183 13.8642L10.5118 7.71425L16.1018 12.8942L14.3718 14.8442L10.3718 10.8442L2.87183 18.3542L4.37183 19.8542L10.3718 13.8442L14.3718 17.8442L17.5618 14.2542L21.4618 17.8642L22.8718 16.4542L18.8918 12.7542L22.8718 8.28425Z"
          fill={DARWIN_RED_2}
        />
      </svg>
      <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8718 8.28425L21.4618 6.87425L17.4318 11.4042L10.3718 4.85425L2.87183 12.3642L4.37183 13.8642L10.5118 7.71425L16.1018 12.8942L14.3718 14.8442L10.3718 10.8442L2.87183 18.3542L4.37183 19.8542L10.3718 13.8442L14.3718 17.8442L17.5618 14.2542L21.4618 17.8642L22.8718 16.4542L18.8918 12.7542L22.8718 8.28425Z"
          fill="#1E2B4E"
        />
      </svg>
    </div>
  );
};

export const ReportsIcon = ({ className }) => {
  return (
    <div className="icon-wrapper">
      <svg
        className={`${className} ${className}-backdrop`}
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.8718 3.85424H15.6918C15.1218 2.29424 13.4018 1.49424 11.8718 2.05424C11.0118 2.35424 10.3718 3.01424 10.0518 3.85424H5.87183C5.34139 3.85424 4.83269 4.06496 4.45761 4.44003C4.08254 4.8151 3.87183 5.32381 3.87183 5.85424V19.8542C3.87183 20.3847 4.08254 20.8934 4.45761 21.2685C4.83269 21.6435 5.34139 21.8542 5.87183 21.8542H19.8718C20.4023 21.8542 20.911 21.6435 21.286 21.2685C21.6611 20.8934 21.8718 20.3847 21.8718 19.8542V5.85424C21.8718 5.32381 21.6611 4.8151 21.286 4.44003C20.911 4.06496 20.4023 3.85424 19.8718 3.85424ZM12.8718 3.85424C13.137 3.85424 13.3914 3.9596 13.5789 4.14713C13.7665 4.33467 13.8718 4.58903 13.8718 4.85424C13.8718 5.11946 13.7665 5.37381 13.5789 5.56135C13.3914 5.74888 13.137 5.85424 12.8718 5.85424C12.6066 5.85424 12.3523 5.74888 12.1647 5.56135C11.9772 5.37381 11.8718 5.11946 11.8718 4.85424C11.8718 4.58903 11.9772 4.33467 12.1647 4.14713C12.3523 3.9596 12.6066 3.85424 12.8718 3.85424ZM7.87183 7.85424H17.8718V5.85424H19.8718V19.8542H5.87183V5.85424H7.87183V7.85424ZM17.8718 11.8542H7.87183V9.85424H17.8718V11.8542ZM15.8718 15.8542H7.87183V13.8542H15.8718V15.8542Z"
          fill="#3DD394"
        />
      </svg>
      <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.8718 3.85424H15.6918C15.1218 2.29424 13.4018 1.49424 11.8718 2.05424C11.0118 2.35424 10.3718 3.01424 10.0518 3.85424H5.87183C5.34139 3.85424 4.83269 4.06496 4.45761 4.44003C4.08254 4.8151 3.87183 5.32381 3.87183 5.85424V19.8542C3.87183 20.3847 4.08254 20.8934 4.45761 21.2685C4.83269 21.6435 5.34139 21.8542 5.87183 21.8542H19.8718C20.4023 21.8542 20.911 21.6435 21.286 21.2685C21.6611 20.8934 21.8718 20.3847 21.8718 19.8542V5.85424C21.8718 5.32381 21.6611 4.8151 21.286 4.44003C20.911 4.06496 20.4023 3.85424 19.8718 3.85424ZM12.8718 3.85424C13.137 3.85424 13.3914 3.9596 13.5789 4.14713C13.7665 4.33467 13.8718 4.58903 13.8718 4.85424C13.8718 5.11946 13.7665 5.37381 13.5789 5.56135C13.3914 5.74888 13.137 5.85424 12.8718 5.85424C12.6066 5.85424 12.3523 5.74888 12.1647 5.56135C11.9772 5.37381 11.8718 5.11946 11.8718 4.85424C11.8718 4.58903 11.9772 4.33467 12.1647 4.14713C12.3523 3.9596 12.6066 3.85424 12.8718 3.85424ZM7.87183 7.85424H17.8718V5.85424H19.8718V19.8542H5.87183V5.85424H7.87183V7.85424ZM17.8718 11.8542H7.87183V9.85424H17.8718V11.8542ZM15.8718 15.8542H7.87183V13.8542H15.8718V15.8542Z"
          fill="#1E2B4E"
        />
      </svg>
    </div>
  );
};

export const AdminIcon = ({ className }) => {
  return (
    <div className="icon-wrapper">
      <svg
        className={`${className} ${className}-backdrop`}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6684 20.1667H9.33172C9.12266 20.1667 8.91987 20.0953 8.75697 19.9643C8.59408 19.8332 8.48088 19.6504 8.43614 19.4462L8.06306 17.7192C7.56536 17.5011 7.09344 17.2284 6.65597 16.9061L4.97206 17.4424C4.77274 17.5059 4.55768 17.4994 4.36258 17.4239C4.16749 17.3483 4.0041 17.2083 3.89956 17.0271L2.22756 14.1387C2.12411 13.9573 2.08527 13.7462 2.11741 13.5399C2.14955 13.3336 2.25076 13.1443 2.40447 13.003L3.71072 11.8113C3.65132 11.2715 3.65132 10.7268 3.71072 10.187L2.40447 8.99804C2.25054 8.85667 2.1492 8.66719 2.11705 8.46068C2.08491 8.25416 2.12387 8.04285 2.22756 7.86137L3.89589 4.97112C4.00044 4.78991 4.16382 4.64992 4.35892 4.57438C4.55401 4.49884 4.76907 4.49231 4.96839 4.55587L6.65231 5.09212C6.87597 4.92712 7.10881 4.77312 7.34897 4.63379C7.58089 4.50362 7.81922 4.38537 8.06306 4.27996L8.43706 2.55479C8.48158 2.35056 8.59457 2.16767 8.75729 2.03646C8.92001 1.90525 9.12269 1.83359 9.33172 1.83337H12.6684C12.8774 1.83359 13.0801 1.90525 13.2428 2.03646C13.4055 2.16767 13.5185 2.35056 13.5631 2.55479L13.9407 4.28087C14.1974 4.39454 14.4486 4.52196 14.6915 4.66404C14.9179 4.79512 15.137 4.93904 15.3478 5.09396L17.0326 4.55771C17.2318 4.49438 17.4467 4.50103 17.6416 4.57655C17.8365 4.65208 17.9997 4.79194 18.1042 4.97296L19.7726 7.86321C19.9852 8.23629 19.9119 8.70837 19.5956 8.99896L18.2894 10.1906C18.3488 10.7304 18.3488 11.2751 18.2894 11.815L19.5956 13.0066C19.9119 13.2981 19.9852 13.7693 19.7726 14.1424L18.1042 17.0326C17.9997 17.2138 17.8363 17.3538 17.6412 17.4294C17.4461 17.5049 17.231 17.5114 17.0317 17.4479L15.3478 16.9116C14.9107 17.2337 14.4391 17.5061 13.9416 17.7238L13.5631 19.4462C13.5184 19.6503 13.4053 19.8329 13.2426 19.964C13.0799 20.095 12.8773 20.1665 12.6684 20.1667V20.1667ZM10.9964 7.33337C10.0239 7.33337 9.0913 7.71968 8.40367 8.40732C7.71603 9.09495 7.32972 10.0276 7.32972 11C7.32972 11.9725 7.71603 12.9051 8.40367 13.5928C9.0913 14.2804 10.0239 14.6667 10.9964 14.6667C11.9689 14.6667 12.9015 14.2804 13.5891 13.5928C14.2767 12.9051 14.6631 11.9725 14.6631 11C14.6631 10.0276 14.2767 9.09495 13.5891 8.40732C12.9015 7.71968 11.9689 7.33337 10.9964 7.33337V7.33337Z"
          fill="#EF6A4D"
        />
      </svg>
      <svg
        className={className}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6684 20.1667H9.33172C9.12266 20.1667 8.91987 20.0953 8.75697 19.9643C8.59408 19.8332 8.48088 19.6504 8.43614 19.4462L8.06306 17.7192C7.56536 17.5011 7.09344 17.2284 6.65597 16.9061L4.97206 17.4424C4.77274 17.5059 4.55768 17.4994 4.36258 17.4239C4.16749 17.3483 4.0041 17.2083 3.89956 17.0271L2.22756 14.1387C2.12411 13.9573 2.08527 13.7462 2.11741 13.5399C2.14955 13.3336 2.25076 13.1443 2.40447 13.003L3.71072 11.8113C3.65132 11.2715 3.65132 10.7268 3.71072 10.187L2.40447 8.99804C2.25054 8.85667 2.1492 8.66719 2.11705 8.46068C2.08491 8.25416 2.12387 8.04285 2.22756 7.86137L3.89589 4.97112C4.00044 4.78991 4.16382 4.64992 4.35892 4.57438C4.55401 4.49884 4.76907 4.49231 4.96839 4.55587L6.65231 5.09212C6.87597 4.92712 7.10881 4.77312 7.34897 4.63379C7.58089 4.50362 7.81922 4.38537 8.06306 4.27996L8.43706 2.55479C8.48158 2.35056 8.59457 2.16767 8.75729 2.03646C8.92001 1.90525 9.12269 1.83359 9.33172 1.83337H12.6684C12.8774 1.83359 13.0801 1.90525 13.2428 2.03646C13.4055 2.16767 13.5185 2.35056 13.5631 2.55479L13.9407 4.28087C14.1974 4.39454 14.4486 4.52196 14.6915 4.66404C14.9179 4.79512 15.137 4.93904 15.3478 5.09396L17.0326 4.55771C17.2318 4.49438 17.4467 4.50103 17.6416 4.57655C17.8365 4.65208 17.9997 4.79194 18.1042 4.97296L19.7726 7.86321C19.9852 8.23629 19.9119 8.70837 19.5956 8.99896L18.2894 10.1906C18.3488 10.7304 18.3488 11.2751 18.2894 11.815L19.5956 13.0066C19.9119 13.2981 19.9852 13.7693 19.7726 14.1424L18.1042 17.0326C17.9997 17.2138 17.8363 17.3538 17.6412 17.4294C17.4461 17.5049 17.231 17.5114 17.0317 17.4479L15.3478 16.9116C14.9107 17.2337 14.4391 17.5061 13.9416 17.7238L13.5631 19.4462C13.5184 19.6503 13.4053 19.8329 13.2426 19.964C13.0799 20.095 12.8773 20.1665 12.6684 20.1667V20.1667ZM10.9964 7.33337C10.0239 7.33337 9.0913 7.71968 8.40367 8.40732C7.71603 9.09495 7.32972 10.0276 7.32972 11C7.32972 11.9725 7.71603 12.9051 8.40367 13.5928C9.0913 14.2804 10.0239 14.6667 10.9964 14.6667C11.9689 14.6667 12.9015 14.2804 13.5891 13.5928C14.2767 12.9051 14.6631 11.9725 14.6631 11C14.6631 10.0276 14.2767 9.09495 13.5891 8.40732C12.9015 7.71968 11.9689 7.33337 10.9964 7.33337V7.33337Z"
          fill="#1E2B4E"
        />
      </svg>
    </div>
  );
};
